import { translateString } from '@src/util/intl/translateString';
const languageData = [
  {
    languageId: 'english',
    locale: 'en',
    name: translateString('languages.english'),
    icon: 'us',
  },
  {
    languageId: 'spanish',
    locale: 'es',
    name: translateString('languages.spanish'),
    icon: 'es',
  },

  // @todo enable languages as soon as we have translations for them
  // {
  //   languageId: 'chinese',
  //   locale: 'zh',
  //   name: 'Chinese',
  //   icon: 'cn',
  // },
  // {
  //   languageId: 'french',
  //   locale: 'fr',
  //   name: 'French',
  //   icon: 'fr',
  // },
  // {
  //   languageId: 'italian',
  //   locale: 'it',
  //   name: 'Italian',
  //   icon: 'it',
  // },
  // {
  //   languageId: 'saudi-arabia',
  //   locale: 'ar',
  //   name: 'Arabic',
  //   icon: 'sa',
  // },
];
export default languageData;
